import interfaceMessages from "../constants/interfaceMessages";
import dialogs from "../dialogs";

const onOpenMurderOnTheOrientExpress = exampleName => {
  if (exampleName.startsWith(interfaceMessages.MURDER_ON_THE_ORIENT_EXPRESS)) {
    dialogs.alertPrompt(
      interfaceMessages.AGATHA_CHRISTIE_ACKNOWLEDGEMENT,
      null,
      interfaceMessages.AGATHA_CHRISTIE_ACKNOWLEDGEMENT_HEADING
    );
  }
};

export { onOpenMurderOnTheOrientExpress };
